<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-list" v-if="resourceReadPermission">
		<div v-if="customConfig.module != 'company'">
			<bread-crumbs
				v-if="!customConfig.popupMode"
				:title="$t('ResourceList')"
				:subTitle="$t('general.SubtitleResource')"
				:sizeTitle="30"
				:lineHeightTitle="37"
				:sizeSubTitle="15"
				:lineHeightSubTitle="18"
			></bread-crumbs>
			<div v-else class="flex items-start justify-between">
				<bread-crumbs
					:title="$t('ResourceList')"
					:subTitle="$t('general.SubtitleResource')"
					:sizeTitle="22"
					:lineHeightTitle="27"
					:sizeSubTitle="13"
					:lineHeightSubTitle="16"
				>
				</bread-crumbs>
				<feather-icon
					icon="XIcon"
					@click.stop="$emit('closePopup', false)"
					class="cursor-pointer"
				></feather-icon>
			</div>
		</div>
		<vs-prompt
			:title="$t('ExportToExcel') + ' ' + $t('Selected')"
			class="export-options"
			@cancel="clearFields"
			@accept="exportList"
			accept-text="Export"
			@close="clearFields"
			:active.sync="activePrompt1"
		>
			<vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
			<v-select v-model="selectedFormat" :options="formats" class="my-4" />
			<div class="flex">
				<span class="mr-4">{{ $t("MapModule.CellAutoWith") }}:</span>
				<vs-switch v-model="cellAutoWidth">{{ $t("MapModule.CellAutoWith") }}</vs-switch>
			</div>
		</vs-prompt>
		<vs-prompt
			:title="$t('ExportToExcel') + ' ' + $t('All')"
			class="export-options"
			@cancel="clearFields"
			@accept="exportList2"
			accept-text="Export"
			@close="clearFields"
			:active.sync="activePrompt2"
		>
			<v-select v-model="typologyIdForExport" :options="typologyOptions" class="my-4" />
			<v-select v-model="selectedFormat" :options="formats" class="my-4" />
			<div class="flex">
				<span class="mr-4">{{ $t("MapModule.CellAutoWith") }}:</span>
				<vs-switch v-model="cellAutoWidth">{{ $t("MapModule.CellAutoWith") }}</vs-switch>
			</div>
		</vs-prompt>
		<div
			:class="customConfig.popupMode === true || customConfig.module === 'massiveassignment' ? '' : 'vx-card p-6'"
		>
			<div v-if="!customConfig.popupMode" class="vx-row">
				<div class="vx-col flex w-full md:w-4/5 mb-2">
					<!-- ITEMS PER PAGE -->
					<template>
						<!-- ITEMS PER PAGE -->
						<vs-dropdown vs-trigger-click class="cursor-pointer mr-2 w-1/2">
							<div
								class="
									p-3
									border border-solid
									d-theme-border-grey-light
									rounded-lg
									d-theme-dark-bg
									cursor-pointer
									font-medium
								"
							>
								<span>{{ $t(`SearchBy`) }} {{ $t(`${searchField}`) }}</span>
								<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
							</div>
							<vs-dropdown-menu>
								<vs-dropdown-item @click="setSearchField('Name')">
									<span>{{ $t("Name") }}</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="setSearchField('Lastname')">
									<span>{{ $t("Lastname") }}</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="setSearchField('Identification')">
									<span>{{ $t("Identification") }}</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="setSearchField('Email')">
									<span>{{ $t("Email") }}</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="setSearchField('Username')">
									<span>{{ $t("User") }}</span>
								</vs-dropdown-item>
							</vs-dropdown-menu>
						</vs-dropdown>
					</template>
					<!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
					<vx-input-group class="w-full">
						<vs-input
							icon-no-border
							class="w-full"
							v-model="searchQuery"
							:placeholder="$t('Search')"
							@keyup.enter="searchResource"
						/>
						<template slot="append">
							<div class="btn-addon">
								<vs-button
									type="filled"
									class="cursor-pointer"
									color="primary"
									icon-pack="feather"
									icon="icon-search"
									:title="$t('Search')"
									@click="searchResource"
								></vs-button>
							</div>
						</template>
					</vx-input-group>
				</div>
				<div class="vx-col flex justify-end items-center md:w-1/5 mb-2">
					<vs-button
						color="primary"
						type="filled"
						icon-pack="feather"
						icon="icon-download"
						class="mr-2 cursor-pointer"
						:title="$t('Export') + ' ' + $t('Resource.Resources')"
						@click.prevent="activateExport"
					></vs-button>
					<vs-button
						type="filled"
						color="primary"
						class="mr-2 cursor-pointer"
						icon-pack="feather"
						icon="icon-refresh-cw"
						:title="$t('Schedule.Refresh')"
						@click.prevent="refresh"
					></vs-button>
					<vs-button
						type="filled"
						icon-pack="feather"
						icon="icon-plus"
						class="cursor-pointer"
						:title="$t('CreateResource')"
						@click.prevent="goToCreate"
					></vs-button>
				</div>
			</div>
			<div v-if="customConfig.popupMode" class="vx-row">
				<div class="vx-col w-full sm:w-1/1 md:w-1/3">
					<v-select
						v-model="searchFieldSelected"
						name="country"
						v-validate="'required'"
						:clearable="false"
						:options="searchOptions"
						:dir="$vs.rtl ? 'rtl' : 'ltr'"
					>
						<template v-slot:no-options="{search, searching}">
							<template v-if="searching">
								{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
							</template>
						</template>
					</v-select>
				</div>
				<div class="vx-col w-full md:w-5/12">
					<vs-input
						class="w-full"
						v-model="searchQuery"
						:placeholder="placeholder"
						@keyup.enter="searchResource"
					/>
				</div>
				<div class="vx-col md:w-1/5 flex items-center">
					<vs-button
						v-if="customConfig.btnAssigResources"
						type="filled"
						color="primary"
						icon-pack="feather"
						icon="icon-search"
						@click="searchResource"
					>
						{{ $t("Search") }}
					</vs-button>
					<vs-button
						type="filled"
						color="primary"
						class="ml-2"
						icon-pack="feather"
						icon="icon-refresh-cw"
						style="width: 167px"
						@click.prevent="refresh"
					></vs-button>
				</div>
			</div>
			<div v-if="customConfig.module === 'report' && customConfig.rowSelection !== 'single'" class="vx-row pt-2">
				<div class="vx-col w-full flex justify-end">
					<p class="g-label--normal text-warning mr-1">{{ $t("general.MaximumResourceReport") }}</p>
					<p class="g-label--normal text-warning" :class="hasAnimation ? 'bounce-enter-active' : ''">
						{{ "(" + getCheckedResources.length + "/3)" }}
					</p>
				</div>
			</div>
			<!--
             AgGrid Table -->
			<ag-grid-vue
				ref="agGridTable"
				class="ag-theme-material w-100 my-4 ag-grid-table"
				colResizeDefault="shift"
				:components="components"
				:gridOptions="gridOptions"
				:columnDefs="columnDefs"
				:defaultColDef="defaultColDef"
				:rowData="resourcesData"
				:rowSelection="customConfig.rowSelection"
				:animateRows="true"
				:floatingFilter="false"
				:pagination="true"
				:paginationPageSize="paginationPageSize"
				:suppressPaginationPanel="true"
				:enableRtl="$vs.rtl"
				@selection-changed="onSelectionChanged"
				@rowSelected="rowSelected"
				@grid-ready="onGridReady"
			>
			</ag-grid-vue>
			<vs-pagination :total="totalPages" :max="5" v-model="currentPage" goto />
			<div v-if="customConfig.btnAssigResources" class="text-right">
				<vs-button
					type="filled"
					color="#31C918"
					class="g-btn--resourcePopup justify-items-end"
					:disabled="!getCheckedResources.length > 0"
					@click="assigSelectedResorces"
				>
					{{ $t("Resource.AssigResources") }}
				</vs-button>
			</div>
		</div>
	</div>
	<not-permission v-else :message="message"></not-permission>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
// Store Module
import moduleResource from "@/store/resource/moduleResource.js";
import moduleSchedule from "@/store/schedule/moduleSchedule.js";
// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import NotPermission from "@/views/pages/NotPermission.vue";
import {firebaseInstance as firebase} from "@/main";

export default {
	props: {
		removeColumns: {
			type: Boolean,
			default: () => false,
			required: false,
		},
		relatedIds: {
			type: Array,
			default: () => [],
		},
		companyId: {
			type: Number,
			default: 0,
		},
		customConfig: {
			type: Object,
			default: () => {
				return {
					activeHeaderCheckboxSelection: true,
					rowSelection: "multiple",
					activeCheckbox: true,
					columns: [],
					actionDropdown: true,
					btnAssigResources: false,
					popupMode: false,
					importMode: false,
					link: true,
					module: "",
				};
			},
		},
		openLoadFileForm: {
			type: Function,
		},
		btnLoadFileForm: {
			type: Boolean,
			default: false,
		},
		maxSelectedRows: {
			type: Number,
			default: 0,
		},
		componentParent: {
			type: String,
			default: "",
		},
	},
	components: {
		AgGridVue,
		vSelect,
		// Cell Renderer
		CellRendererLink,
		CellRendererStatus,
		CellRendererVerified,
		CellRendererActions,
		NotPermission,
	},
	data() {
		return {
			// Filter Options
			roleFilter: {label: "All", value: "all"},
			statusFilter: {label: "All", value: "all"},
			isVerifiedFilter: {label: "All", value: "all"},
			isVerifiedOptions: [
				{label: "All", value: "all"},
				{label: "Yes", value: "yes"},
				{label: "No", value: "no"},
			],
			departmentFilter: {label: "All", value: "all"},
			searchQuery: "",
			// AgGrid
			gridApi: null,
			gridOptions: {},
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
			},
			// Cell Renderer Components
			components: {
				CellRendererLink,
				CellRendererStatus,
				CellRendererVerified,
				CellRendererActions,
			},
			// columns config
			columnsConfigWidth: {
				email: this.removeColumns ? 300 : 225,
				lastname: this.removeColumns ? 250 : 200,
				identification: this.removeColumns ? 250 : 200,
				name: this.removeColumns ? 250 : 200,
				username: this.removeColumns ? 250 : 300,
			},
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			currentPageLocal: 1,
			quantityElementPage: 12,
			radioTypeSearch: "default",
			searchField: "Name",
			//Variables to Export Files
			fileName: "",
			formats: ["xlsx", "csv", "txt"],
			cellAutoWidth: true,
			selectedFormat: "xlsx",
			activePrompt1: false,
			activePrompt2: false,
			headerTitle: [
				this.$t("Name"),
				this.$t("Lastname"),
				this.$t("Username"),
				this.$t("Email"),
				this.$t("Identification"),
				"imei",
				this.$t("Role"),
				"alias",
				"added_on",
				"update_on",
				this.$t("Address"),
			],
			headerVal: [
				"name",
				"lastname",
				"username",
				"email",
				"identification",
				"imei",
				"role_name",
				"alias",
				"added_on",
				"update_on",
				"address",
			],
			selectedResourcesToExport: [],
			typologyIdForExport: 0,
			typologyOptions: [],
			hasAnimation: false,
			searchFieldSelected: {value: "Name", label: this.$t("Name")},
		};
	},
	watch: {
		roleFilter(obj) {
			this.setColumnFilter("role", obj.value);
		},
		statusFilter(obj) {
			this.setColumnFilter("status", obj.value);
		},
		isVerifiedFilter(obj) {
			const val = obj.value === "all" ? "all" : obj.value === "yes" ? "true" : "false";
			this.setColumnFilter("is_verified", val);
		},
		departmentFilter(obj) {
			this.setColumnFilter("department", obj.value);
		},
		currentPage(val) {
			this.getResources();
			this.messages = [];
			this.currentSelectResource = null;
		},
		quantityElementPage() {
			this.currentPage = 1;
			this.getResources();
		},
		radioTypeSearch() {
			this.searchQuery = "";
			this.resetColFilters();
			if (this.radioTypeSearch === "default") {
				this.getResources();
			}
		},
		searchFieldSelected(obj) {
			this.searchField = obj.value;
		},
	},
	beforeDestroy() {
		this.$store.commit("moduleResource/CLEAR_DEL_RESOURCE_CHECKED");
		this.$store.commit("moduleResource/SET_SELECTED_RESOURCE_PAGES", []);
	},
	computed: {
		// Colunms to render
		columnDefs() {
			let filterHead = false;
			// Columns
			let columns = [
				{
					headerName: this.$t("Username"),
					field: "username",
					filter: filterHead,
					width: this.columnsConfigWidth.username,
					cellRendererFramework: this.customConfig.link ? "CellRendererLink" : "",
					checkboxSelection:
						this.customConfig.activeCheckbox !== undefined ? this.customConfig.activeCheckbox : true,
					headerCheckboxSelectionFilteredOnly: true,
					headerCheckboxSelection:
						this.customConfig.rowSelection === "multiple" && this.customConfig.activeHeaderCheckboxSelection
							? true
							: false,
				},
				{
					headerName: "ID",
					field: "id",
					width: 150,
					filter: filterHead,
				},
				{
					headerName: this.$t("Name"),
					field: "name",
					filter: filterHead,
					width: this.columnsConfigWidth.name,
				},
				{
					headerName: this.$t("Lastname"),
					field: "lastname",
					filter: filterHead,
					width: this.columnsConfigWidth.lastname,
				},
				{
					headerName: this.$t("Email"),
					field: "email",
					filter: filterHead,
					width: this.columnsConfigWidth.email,
				},
				{
					headerName: this.$t("Identification"),
					field: "identification",
					filter: filterHead,
					width: this.columnsConfigWidth.identification,
				},
				{
					headerName: this.$t("Role"),
					field: "alias",
					filter: filterHead,
					width: 150,
				},
				{
					headerName: this.$t("Status"),
					field: "status",
					filter: filterHead,
					width: 150,
					cellRendererFramework: "CellRendererStatus",
				},
				{
					headerName: this.$t("Type"),
					field: "typology_name",
					filter: filterHead,
					width: 150,
				},
				{
					headerName: this.$t("Groups.TotalGroups"),
					field: "total_group",
					filter: filterHead,
					width: 150,
				},
				{
					headerName: this.$t("Actions"),
					field: "transactions",
					width: 150,
					cellRendererFramework: "CellRendererActions",
					pinned: "right",
				},
			];

			// Filter table columns to show if showColumns is provided
			const showColumns =
				this.customConfig.columns !== undefined && this.customConfig.columns.length > 0
					? this.customConfig.columns
					: [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}
			return columns;
		},
		resourcesData() {
			if (this.companyId > 0) {
				return this.$store.state.moduleResource.resources.filter((resource) => resource.role_name === "ADMIN");
			} else {
				return this.$store.state.moduleResource.resources;
			}
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		resourceReadPermission() {
			return this.$store.getters.checkPermission("RESOURCES_R");
		},
		roleRPermission() {
			return this.$store.getters.checkPermission("ROLE_R");
		},
		message() {
			return `${this.$t("Permissions.RequiredPermissions")} "RESOURCES_R""`;
		},
		getCheckedResources() {
			return this.$store.state.moduleResource.checkedResources;
		},
		searchOptions() {
			return [
				{value: "Name", label: this.$t("Name")},
				{value: "Lastname", label: this.$t("Lastname")},
				{value: "Identification", label: this.$t("Identification")},
				{value: "Email", label: this.$t("Email")},
				{value: "Username", label: this.$t("Username")},
				{value: "Imei", label: "Imei"},
				{value: "Id", label: "ID"},
			];
		},
		placeholder() {
			return this.searchField === "Id" ? this.$t("Resource.SearchMultipleId") : this.$t("Search");
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		paginationSetPageSize(num) {
			this.quantityElementPage = num;
		},
		getResources(
			dataPage = {
				page: this.currentPage,
				quantity: this.quantityElementPage,
				order_by: "added_on",
				sort: "DESC",
			}
		) {
			if (this.companyId > 0) {
				dataPage["company_id"] = this.companyId;
			}
			if (this.componentParent === "ResourceListVisitPoint") {
				dataPage["role_id"] = this.$store.getters["moduleRoles/getExcuteSupervisorRolesId"];
			}
			this.openLoading();
			this.$store
				.dispatch("moduleResource/fetchResourceFilter", dataPage)
				.then((res) => {
					Object.assign(this.pagination, res.data.pagination);
					this.setDefaultSelectedRow();
					this.closeLoading();
					setTimeout(() => {
						this.resetColFilters();
					}, 100);
				})
				.catch((err) => {
					this.closeLoading();
					if (error.status === 722) {
						this.$vs.notify({
							color: "danger",
							title: this.$t("Roles.Permissions.NotPermissionsTitle"),
							text: `${this.$t("Roles.Permissions.NotPermissionsText")} ${error.error}`,
							time: 5000,
						});
					}
					throw new Error(err);
				});
		},
		setColumnFilter(column, val) {
			const filter = this.gridApi.getFilterInstance(column);
			let modelObj = null;
			if (val !== "all") {
				modelObj = {type: "equals", filter: val};
			}
			filter.setModel(modelObj);
			this.gridApi.onFilterChanged();
		},
		resetColFilters() {
			if (this.gridApi) {
				this.gridApi.setFilterModel(null);
				this.gridApi.onFilterChanged();
			}
		},
		setDefaultSelectedRow() {
			const relatedIds = this.getCheckedResources;
			if (relatedIds.length > 0) {
				this.gridApi.forEachNode((node) => {
					const valid = relatedIds.some((r) => r.id === node.data.id);
					node.setSelected(valid);
				});
			}
		},
		updateSearchQuery(val) {
			if (this.radioTypeSearch === "default") this.gridApi.setQuickFilter(val);
		},
		goToCreate() {
			this.$router.push(`/apps/resource/resource-create`);
		},
		//CODIGO PARA EXPORTAR
		activateExport() {
			if (this.getCheckedResources.length >= 1) {
				this.showActivePrompt1();
			} else {
				this.showActivePrompt2();
			}
		},
		async exportList() {
			this.openLoading();
			await import("@/vendor/Export2Excel").then((excel) => {
				const list = this.getCheckedResources;
				const data = this.formatJson(this.headerVal, list);
				excel.export_json_to_excel({
					header: this.headerTitle,
					data,
					filename: this.fileName,
					autoWidth: this.cellAutoWidth,
					bookType: this.selectedFormat,
				});
				this.clearFields();
				this.closeLoading();
			});
		},
		async exportList2() {
			//From BACKEND all resources
			this.openLoading();
			let payload = {
				typology_id: this.typologyIdForExport.value,
				type_file: this.selectedFormat,
			};
			await this.$store
				.dispatch("moduleResource/downloadResources", payload)
				.then((res) => {
					if (res.data === null || res.data.length === 0) {
						this.$vs.notify({
							color: "danger",
							title: this.$t(""),
							text: this.$t("MapModule.ResourcesNotFound"),
						});
						this.closeLoading();
						return;
					}
					this.closeLoading();
					const storageRef = firebase.storage().ref(res.data.bucket_path);
					storageRef.getDownloadURL().then(function (url) {
						const downloadInstance = document.createElement("a");
						downloadInstance.href = url;
						downloadInstance.target = "_blank";
						downloadInstance.download = "default.xlsx";
						document.body.appendChild(downloadInstance);
						downloadInstance.click();
						document.body.removeChild(downloadInstance);
					});
				})
				.catch((err) => {
					this.closeLoading();
					this.$vs.notify({
						color: "danger",
						title: this.$t(""),
						text: this.$t("MapModule.ResourcesNotFound"),
					});
					throw new Error(err);
				});
			this.$nextTick(() => this.closeLoading());
		},
		clearFields() {
			this.fileName = "";
			this.cellAutoWidth = true;
			this.selectedFormat = "xlsx";
		},
		formatJson(filterVal, jsonData) {
			return jsonData.map((v) =>
				filterVal.map((j) => {
					return v[j];
				})
			);
		},
		showActivePrompt1() {
			this.activePrompt1 = true;
		},
		showActivePrompt2() {
			this.activePrompt2 = true;
		},
		async typologyOptionsFetch() {
			let categories = [];
			const payload = {
				role: [],
				status: [],
				category: "RESOURCE",
				typology: [],
			};
			await this.$store
				.dispatch("moduleResource/fetchDataSelect", payload)
				.then((res) => {
					categories = res.data.category.map((ele) => {
						return {label: ele.typology_name, value: ele.typology_id};
					});
					this.typologyOptions = categories;
					this.typologyIdForExport = categories[0];
				})
				.catch((error) => {
					throw new Error(error);
				});
			return categories;
		},
		//FIN CODIGO PARA EXPORTAR
		getSelectedResources() {
			const selectedRows = this.gridApi.getSelectedRows();
			this.$emit("selectedResourcesEmit", selectedRows);
		},
		rowSelected(event) {
			if (this.selectedResourcesToExport.some((ele) => ele.id === event.data.id)) {
				this.selectedResourcesToExport = this.selectedResourcesToExport.filter(
					(ele2) => ele2.id !== event.data.id
				);
			} else {
				event.data["address"] = event.data.additional_info.direccion;
				this.selectedResourcesToExport.push(event.data);
			}
			this.hasAnimation = !this.hasAnimation;
			if (this.maxSelectedRows > 0 && this.getCheckedResources.length >= this.maxSelectedRows) {
				this.gridApi.getRowNode(event.rowIndex).setSelected(false);
				this.hasAnimation = false;
			}
			const isSelected = event.node.isSelected();
			if (isSelected) {
				// Almacenamos en el state el ultimo valor seleccionado del listado
				this.$store.commit("moduleResource/ADD_RESOURCE_CHECKED", event.data);
				this.$emit("selected", event.data);
			} else {
				this.$store.commit("moduleResource/DEL_RESOURCE_CHECKED", event.data);
			}
			this.$store.dispatch("moduleSchedule/selectedResource", event.data);
			this.$store.commit("moduleResource/CURRENT_SELECTED_RESOURCE", event.data);
		},
		onSelectionChanged() {
			const selectedRows = [...this.getCheckedResources];
			if (this.customConfig.rowSelection === "single") {
				this.$store.commit("moduleResource/CURRENT_SELECTED_RESOURCE", selectedRows[0]);
			} else {
				this.$store.commit("moduleResource/SET_SELECTED_RESOURCE_PAGES", selectedRows);
				this.$store.dispatch("moduleSchedule/selectedResource", selectedRows);
			}
		},
		selectDataRowSelected() {
			const relatedIds = this.getCheckedResources;
			if (relatedIds.length > 0) {
				this.gridApi.forEachNode((node) => {
					const valid = relatedIds.some((r) => r.id === node.data.id);
					node.setSelected(valid);
				});
			}
		},
		onGridReady() {
			this.gridApi = this.gridOptions.api;
		},
		// Este metodo se utiliza cuando el componente esta mondatos desde el componente de actividades
		assigSelectedResorces() {
			const selectedRows = [...this.getCheckedResources];
			if (this.customConfig.rowSelection === "single") {
				// Si la asignacion es single y ya se encuentra algun elemento agregado se limpia
				// y se agrega el actual, para evitar que se asignen varios elementos al abrir el popup de seleccion varias veces
				if (this.$store.state.moduleResource.resourcesActivity.length > 0) {
					this.$store.commit("moduleResource/CLEAN_RESOURCE_ACTIVITY", []);
				}
				this.$store.dispatch("moduleResource/addResourceActivity", selectedRows);
			} else {
				if (
					this.$store.state.moduleResource.resourcesActivity.length > 0 &&
					this.customConfig.module === "report"
				) {
					this.$store.commit("moduleResource/CLEAN_RESOURCE_ACTIVITY", []);
				}
				this.$store.dispatch("moduleResource/addResourceActivity", selectedRows);
			}
			this.$emit("showPopupEmmit", false);
		},
		searchResource() {
			let ids = [];
			if (this.searchField === "Id") {
				const splitted = this.searchQuery.split(",");
				ids = Array.isArray(splitted) ? splitted.map(Number).filter((n) => n) : "";
			}
			const dataPage = {
				name: this.searchField === "Name" ? this.searchQuery : "",
				lastname: this.searchField === "Lastname" ? this.searchQuery : "",
				username: this.searchField === "Username" ? this.searchQuery : "",
				identification: this.searchField === "Identification" ? this.searchQuery : "",
				email: this.searchField === "Email" ? this.searchQuery : "",
				imei: this.searchField === "Imei" ? this.searchQuery : "",
				ids,
				order_by: "name",
				sort: "ASC",
			};
			this.getResources(dataPage);
		},
		setSearchField(val) {
			this.searchField = val;
		},
		refresh() {
			this.$store.commit("moduleResource/SET_SELECTED_RESOURCE_PAGES", []);
			this.searchQuery = "";
			this.currentPage = 1;
			this.getResources();
		},
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.getResources();
		});
	},
	mounted() {
		this.gridApi = this.gridOptions.api;
		/* =================================================================
          NOTE:
          Header is not aligned properly in RTL version of agGrid table.
          However, we given fix to this issue. If you want more robust solution please contact them at gitHub
        ================================================================= */
		if (this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container");
			header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`;
		}
		this.setDefaultSelectedRow();
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}

		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}

		if (this.customConfig.popupMode || this.customConfig.importMode) {
			this.getResources();
		}
		this.typologyOptionsFetch();
	},
};
</script>

<style lang="scss" scoped>
#page-user-list {
	.user-list-filters {
		.vs__actions {
			position: absolute;
			right: 0;
			top: 50%;
			transform: translateY(-58%);
		}
	}

	.radio-alignment {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-items: center;

		& > * {
			margin-right: 1.5rem;
			margin-top: 1.5rem;
		}
	}
}

.ag-grid-table {
	@media screen and (max-height: 800px) {
		height: 290px;
	}
}

.bounce-enter-active {
	animation: bounce-in 0.5s;
	color: #ff9f43;
	font-weight: bold;
}

@keyframes bounce-in {
	0% {
		transform: scale(0);
	}
	50% {
		transform: scale(1.5);
	}
	100% {
		transform: scale(1);
	}
}
</style>
